/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The YearMonth model module.
 * @module model/YearMonth
 * @version 1.0
 */
class YearMonth {
    /**
     * Constructs a new <code>YearMonth</code>.
     * @alias module:model/YearMonth
     */
    constructor() { 
        
        YearMonth.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>YearMonth</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/YearMonth} obj Optional instance to populate.
     * @return {module:model/YearMonth} The populated <code>YearMonth</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new YearMonth();

            if (data.hasOwnProperty('iChronology')) {
                obj['iChronology'] = ApiClient.convertToType(data['iChronology'], Object);
            }
            if (data.hasOwnProperty('iValues')) {
                obj['iValues'] = ApiClient.convertToType(data['iValues'], ['Number']);
            }
        }
        return obj;
    }


}

/**
 * @member {Object} iChronology
 */
YearMonth.prototype['iChronology'] = undefined;

/**
 * @member {Array.<Number>} iValues
 */
YearMonth.prototype['iValues'] = undefined;






export default YearMonth;

